

















































import {Component, Vue, Prop} from 'vue-property-decorator'

@Component
export default class KInputText extends Vue {
  @Prop({default: '', type: String}) value
  @Prop({required: false}) label
  @Prop({required: false}) enabledDelete
  @Prop({required: false}) actionText
  @Prop({required: false}) rules
  @Prop({required: false}) rulesMessage
  @Prop({required: false}) nullText

  visibleExtra: boolean = false

  focused: boolean = false
  valid: boolean = true
  invalidMessage: string = ''

  get inputClass() {
    return {
      'is-focused': this.focused,
      'is-invalid': !this.valid
    }
  }

  get validValue() {
    return (this.value === null || this.value.trim().length === 0) && this.nullText !== undefined ? this.nullText : this.value
  }

  get readonly(): boolean {
    return Boolean(this.$attrs.readonly)
  }

  get hasDelete(): boolean {
    return this.enabledDelete !== undefined
  }

  get hasAction(): boolean {
    return this.actionText !== undefined
  }

  get nativeInputValue() {
    return this.value === null || this.value === undefined ? '' : String(this.value)
  }

  validate() {
    if(this.rules) {
      const input = this.getInput()
      const validCode = this.rules(input.value)
      this.valid = validCode === null
      this.$emit('validate', this.valid)
      if(!this.valid && this.rulesMessage) {
        this.invalidMessage = this.rulesMessage[validCode]
      }
    }
  }

  setNativeInputValue() {
    const input = this.getInput()
    if(!input) return
    if(input.value === this.nativeInputValue) return
    input.value = this.nativeInputValue
  }

  onDelete() {
    this.$emit('input', '')
    this.$emit('change', '')
    this.$emit('clear')
    this.$nextTick(this.setNativeInputValue)
  }

  onInput(event) {
    if(event.target.value === this.nativeInputValue) return
    this.$emit('input', event.target.value)
    this.$nextTick(this.setNativeInputValue)
    this.validate()
  }

  onFocus(event) {
    this.focused = true
    this.$emit('focus', event)
  }

  onBlur(event) {
    this.focused = false
    this.$emit('blur', event)
  }

  onChange(event) {
    this.$emit('change', event.target.value)
    this.validate()
  }

  getInput(): HTMLInputElement {
    return this.$refs.input as HTMLInputElement
  }

  mounted() {
    this.visibleExtra = Boolean(this.$slots.extra)
    this.validate()
  }

  updated() {
    this.visibleExtra = Boolean(this.$slots.extra)
    this.validate()
  }
}
